<pv-drawer
  *ngIf="showModal"
  [isVisible]="showModal"
  [showBackdrop]="true"
  [dismissOnBackdropClick]="true"
  [closeOnEscape]="true"
  [showCloseIcon]="true"
  [style]="pvDrawerConfig"
  [headerTemplate]="headerTemplate"
  [contentTemplate]="contentTemplate"
  [footerTemplate]="footerTemplate"
  class="voucherRedemptionModal"
  (closeHandler)="closeAuthModal()">
  <ng-template #headerTemplate>
    <div
      class="flex flex-row justify-content-between w-full pt-3 align-items-center">
      <div class="text-2xl px-3 font-bold text-primary">
        {{ env.staticTextContents.loginModal.heading }}
      </div>
      <img
        alt="Visa-secure-icon"
        class="h-3rem"
        loading="lazy"
        src="https://images.poshvine.com/visa/visa-secure.png" />
    </div>
  </ng-template>
  <ng-template #contentTemplate>
    <div
      *ngIf="showAuthSection"
      class="flex flex-column justify-content-between text-color h-full h-36rem bg-white m-sticky-bottom">
      <div
        *ngIf="activeScreen === 'landing'"
        class="flex flex-column m-auto px-4 align-items-center">
        <p class="text-center m-2">
          {{ env.staticTextContents.loginModal.landingSectionTitle }}
        </p>
      </div>
      <div *ngIf="activeScreen === 'mobile'">
        <div class="px-4 flex flex-column h-full">
          <form [formGroup]="authForm">
            <div class="flex flex-row align-items-center gap-2">
              <p class="text-xs font-semibold py-2" *ngIf="isSignUp === true">
                {{ env.staticTextContents.loginModal.cardNumberLabel }}
              </p>
              <span
                *ngIf="isSignUp === true"
                tabindex="0"
                pTooltip="Please ensure international transactions are enabled on your card"
                tooltipPosition="top"
                class="info-icon cursor-pointer font-bold"
                [tooltipEvent]="isMobile ? 'focus' : 'hover'">
                ⓘ
              </span>
            </div>
            <div
              *ngIf="isSignUp === true"
              class="border-round flex justify-content-between align-items-center p-0"
              [ngClass]="{
                'is-invalid':
                  submitted &&
                  (authForm.errors ||
                    authForm.controls['inpOne'].errors ||
                    authForm.controls['inpTwo'].errors ||
                    authForm.controls['inpThree'].errors ||
                    authForm.controls['inpFour'].errors)
              }">
              <div
                class="h-3rem"
                *ngFor="let inp of cardFormInput; let idx = index">
                <input
                  #cardFormRow
                  id="cardNumberInp"
                  type="tel"
                  inputmode="numeric"
                  [formControlName]="inp"
                  maxlength="4"
                  class="p-3 border w-5rem input-border border-round-sm letter-spacing"
                  required
                  (focus)="setActiveElement('cardNumberInp')"
                  (keydown)="numericKeyDownEvent($event)"
                  (keyup)="cardKeyUpEvent($event, idx, emailInput)"
                  (blur)="setActiveElement(null)"
                  [ngClass]="{
                    'is-invalid': submitted && authForm.controls[inp].errors
                  }" />
              </div>
            </div>
            <p class="text-xs font-semibold mt-3 py-2">
              {{ env.staticTextContents.loginModal.emailIdLabel }}
            </p>
            <div class="flex w-full gap-3">
              <input
                #emailInput
                autofocusInp
                id="emailId"
                type="email"
                inputmode="email"
                [pattern]="EMAIL_PATTERN"
                formControlName="emailId"
                [maxlength]="emailLength.max"
                class="p-3 w-full input-border border-round-sm"
                required
                (keydown)="emailKeyDownEvent($event)"
                (focus)="setActiveElement('emailId')"
                (blur)="setActiveElement(null)"
                [placeholder]="env.staticTextContents.loginModal.emailIdLabel"
                [ngClass]="{
                  'is-invalid':
                    submitted &&
                    (authForm.errors || authForm.controls['emailId'].errors)
                }" />
            </div>
            <small
              *ngIf="authForm?.errors?.['customError']"
              class="text-red-500 fnt-10">
              {{ customErrorMessage }}
            </small>
            <small
              *ngIf="
                submitted &&
                (authForm?.errors || authForm?.controls?.['emailId']?.errors)
              "
              class="text-red-500 fnt-10">
              <div
                *ngIf="
                  this.emailId.length > 0 &&
                  authForm?.controls?.['emailId']?.errors
                ">
                {{ env.staticTextContents.loginModal.emailIdErrorMsg }}
              </div>
            </small>
            <ng-container *ngIf="showCheckboxes">
              <div class="flex mt-3 py-2 w-full gap-2">
                <input
                  autofocusInp
                  type="checkbox"
                  inputmode="checkBox"
                  formControlName="consent1"
                  class="input-border border-round-sm align-self-start mt-1"
                  required
                  [ngClass]="{
                    'is-invalid':
                      submitted &&
                      (authForm.errors || authForm.controls['consent1'].errors)
                  }" />
                <div class="w-full consent text-xs align-items-center country">
                  {{ env.staticTextContents.loginModal.consent1.text }}
                  <a
                    class="underline"
                    target="_blank"
                    href="/info/terms-and-conditions"
                    rel="noopener noreferrer">
                    {{
                      env.staticTextContents.footerComponent
                        .termsAndConditionsLabel
                    }}
                  </a>
                  &
                  <a
                    class="underline"
                    target="_blank"
                    href="/info/privacy-policy"
                    rel="noopener noreferrer">
                    {{
                      env.staticTextContents.footerComponent.privacyPolicyLabel
                    }}
                  </a>
                  .
                </div>
              </div>
              <div class="flex py-2 w-full gap-2">
                <input
                  autofocusInp
                  type="checkbox"
                  inputmode="checkBox"
                  formControlName="consent2"
                  class="input-border border-round-sm align-self-start mt-1"
                  required
                  [ngClass]="{
                    'is-invalid':
                      submitted &&
                      (authForm.errors || authForm.controls['consent2'].errors)
                  }" />
                <div class="w-full consent text-xs align-items-center">
                  {{ env.staticTextContents.loginModal.consent2.body }}
                  <a
                    rel="noopener noreferrer"
                    class="underline"
                    target="_blank"
                    href="https://www.visa.co.in/legal/global-privacy-notice.html">
                    {{ env.staticTextContents.loginModal.consent2.link }}
                  </a>
                  .
                </div>
              </div>
            </ng-container>
          </form>
        </div>
      </div>
      <div *ngIf="activeScreen === 'otp'">
        <div class="px-4 flex flex-column mt-0 mt-md-3">
          <div class="px-3">
            <div class="flex flex-row align-items-center">
              <p class="opacity-50 text-sm">
                {{ env.staticTextContents.loginModal.otpMessages.enter }}
                <span>{{ this.emailId }}</span>
              </p>
              <button
                name="otp-change-number-button"
                (click)="changeNumber()"
                type="button"
                class="opacity-100 border-none ml-1 bg-white text-primary w-100 font-semibold cursor-pointer">
                {{ env.staticTextContents.loginModal.change }}
              </button>
              <span
                tabindex="0"
                *ngIf="env.otpTooltipFlag"
                [pTooltip]="
                  env.staticTextContents.loginModal.otpMessages.tooltip
                "
                tooltipPosition="top"
                class="info-icon cursor-pointer font-bold"
                [tooltipEvent]="isMobile ? 'focus' : 'hover'">
                ⓘ
              </span>
            </div>
          </div>

          <form [formGroup]="otpForm" class="rounded-top pt-2 px-3 px-md-5">
            <div class="mb-3">
              <div class="flex justify-content-between mar-bot-4">
                <div *ngFor="let input of otpFormInput; index as i">
                  <input
                    (input)="onInputChange($event)"
                    #otpFormRow
                    type="number"
                    inputmode="numeric"
                    formControlName="{{ input }}"
                    class="w-3rem h-3rem text-center input-border border-round-sm"
                    maxlength="1"
                    (focus)="focusFirstEmptyInput()"
                    (keyup)="otpKeyUpEvent($event, i)"
                    (paste)="onOtpPaste($event)"
                    [class.otp-invalid]="otpForm.invalid" />
                </div>
              </div>
              <small
                *ngIf="submitted && otpForm?.errors"
                class="text-red-500 fnt-10">
                <span class="text-red-500" *ngIf="otpForm?.errors">
                  {{ customErrorMessage }}
                </span>
              </small>
            </div>
          </form>
          <div class="flex px-3 fnt-12 mar-bot-8 f400">
            <p class="ms-1" *ngIf="otpTimer !== null">
              {{
                env.staticTextContents.loginModal.otpMessages.resendIn +
                  ' ' +
                  otpTimer
              }}
            </p>
            <button
              name="otp-resend-button"
              class="ms-1 btn bg-primary cursor-pointer text-white"
              (click)="resendOTP()"
              *ngIf="otpTimer === null">
              {{ env.staticTextContents.loginModal.otpMessages.resend }}
            </button>
          </div>
          <small class="text-success fnt-10 text-center" *ngIf="isOtpResent">
            {{ env.staticTextContents.loginModal.otpMessages.sent }}
          </small>
        </div>
      </div>
      <div *ngIf="activeScreen === 'card'">
        <div class="px-4 flex flex-column mt-0 mt-md-3">
          <p class="text-2xl font-semibold text-primary my-3">
            {{ env.staticTextContents.loginModal.cardVerification }}
          </p>
          <form class="card-form" [formGroup]="cardDetailsForm">
            <div
              class="flex flex-row border-gray-100 border-1 font-normal align-items-center border-round pb-1">
              <img
                [height]="12"
                class="pl-2"
                alt="visa-logo"
                loading="lazy"
                src="https://images.poshvine.com/visa-contactless/visalogo.png" />
              <div class="flex gap-1 flex-column p-2">
                <span class="text-xs line-height-1">
                  {{ env.staticTextContents.loginModal.visaCard }}
                </span>
                <span class="line-height-1">
                  {{ cardNumber | slice: 0 : 4 }} -
                  {{ cardNumber | slice: 4 : 6 }}XX - XXXX-
                  {{ cardNumber | slice: -4 }}
                </span>
              </div>
            </div>
            <div class="flex flex-column gap-1 w-full border-round border">
              <p class="text-xs font-semibold mt-3 py-2">
                {{ env.staticTextContents.loginModal.expiryDate }}
              </p>
              <div class="flex flex-row gap-2">
                <input
                  #expiryInpMM
                  type="text"
                  inputmode="numeric"
                  formControlName="expiryMM"
                  maxlength="2"
                  class="input-border border-round-sm w-full p-2 px-3"
                  required
                  [placeholder]="
                    env.staticTextContents.loginModal.placeholders.month
                  "
                  (focus)="setActiveElement('expiryMM')"
                  (keydown)="numericKeyDownEvent($event)"
                  (keyup)="expiryMMKeyDownEvent($event, expiryInpYY)"
                  (blur)="setActiveElement(null)"
                  [ngClass]="{
                    'is-invalid':
                      submitted && cardDetailsForm.controls['expiryMM'].errors
                  }" />
                <input
                  #expiryInpYY
                  type="text"
                  inputmode="numeric"
                  formControlName="expiryYY"
                  maxlength="2"
                  class="input-border border-round-sm w-full p-2 px-3"
                  required
                  [placeholder]="
                    env.staticTextContents.loginModal.placeholders.year
                  "
                  (focus)="setActiveElement('expiryYY')"
                  (keydown)="numericKeyDownEvent($event)"
                  (blur)="setActiveElement(null)"
                  [ngClass]="{
                    'is-invalid':
                      submitted && cardDetailsForm.controls['expiryYY'].errors
                  }" />
              </div>
              <small
                *ngIf="
                  submitted &&
                  cardDetailsForm?.controls?.['expiryMM']?.errors?.['required']
                "
                class="text-red-500 fnt-10">
                {{
                  env.staticTextContents.loginModal.errorMsgs.expiry.month
                    .required
                }}
              </small>
              <small
                *ngIf="
                  submitted &&
                  cardDetailsForm?.controls?.['expiryMM']?.errors?.[
                    'invalidDate'
                  ]
                "
                class="text-red-500 fnt-10">
                {{
                  env.staticTextContents.loginModal.errorMsgs.expiry.month
                    .invalid
                }}
              </small>
              <small
                *ngIf="
                  submitted &&
                  cardDetailsForm?.controls?.['expiryYY']?.errors?.['required']
                "
                class="text-red-500 fnt-10">
                {{
                  env.staticTextContents.loginModal.errorMsgs.expiry.year
                    .required
                }}
              </small>
              <small
                *ngIf="
                  submitted &&
                  cardDetailsForm?.controls?.['expiryYY']?.errors?.[
                    'invalidDate'
                  ]
                "
                class="text-red-500 fnt-10">
                {{
                  env.staticTextContents.loginModal.errorMsgs.expiry.year
                    .invalid
                }}
              </small>
              <small
                *ngIf="cardDetailsForm?.errors?.['customError']"
                class="text-red-500 fnt-10">
                {{ customErrorMessage }}
              </small>
            </div>
          </form>
        </div>
      </div>
      <div
        *ngIf="activeScreen === 'bankVerification'"
        class="flex flex-column p-4 align-items-center m-auto">
        <img
          alt="Unlock-voucher-icon"
          loading="lazy"
          src="https://images.poshvine.com/visa-contactless/waiting.png" />
        <p class="text-2xl font-semibold text-center text-primary m-2">
          {{ env.staticTextContents.loginModal.waitingForBank }}
        </p>
        <p class="text-center m-2">
          {{ env.staticTextContents.loginModal.takeFewMinutes }}
        </p>
      </div>
      <div
        *ngIf="activeScreen === 'bankAuthenticated'"
        class="flex flex-column p-4 align-items-center m-auto">
        <img
          alt="Unlock-voucher-icon"
          class="mb-3"
          loading="lazy"
          src="https://images.poshvine.com/visa-contactless/authenticated.png" />
        <p class="text-2xl font-semibold text-center text-primary m-2">
          {{ env.staticTextContents.loginModal.authPassMsg }}
        </p>
        <p class="text-center m-2">
          {{ env.staticTextContents.loginModal.unlockingVouchers }}
        </p>
      </div>
      <div
        *ngIf="activeScreen === 'bankAuthenticationFailed'"
        class="flex flex-column p-4 align-items-center m-auto">
        <img
          alt="Unlock-voucher-icon"
          loading="lazy"
          src="https://images.poshvine.com/visa-contactless/alert-triangle.png" />
        <p class="text-2xl font-semibold text-center text-primary m-2">
          {{ env.staticTextContents.loginModal.authFailMsg }}
        </p>
        <p *ngIf="env.loginModal.faqLine" class="text-primary">
          {{ env.staticTextContents.loginModal.faqLine.before }}
          <!-- prettier-ignore -->
          <a
            class="text-primary"
            [href]="env.footerComponent.faqLink"
            target="_blank">
            {{env.staticTextContents.loginModal.faqLine.link}}</a>
          {{ env.staticTextContents.loginModal.faqLine.after }}
        </p>
        <button
          name="bank-authentication-failed-try-again-button"
          class="btn bg-white text-primary w-100 font-semibold cursor-pointer"
          (click)="tryAgain()">
          {{ env.staticTextContents.loginModal.tryAgain }}
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="bg-white sticky bottom-0 px-4 flex flex-column">
      <div
        *ngIf="activeScreen === 'mobile' || activeScreen === 'otp'"
        class="flex flex-row bg-gray-100 font-normal align-items-center border-round mb-3 p-1">
        <img
          class="m-1"
          [width]="34"
          [height]="34"
          alt="Indian-flag"
          src="https://images.poshvine.com/visa-contactless/pcidss.png" />
        <span class="text-xs">
          {{ env.staticTextContents.loginModal.pcidssText }}
        </span>
      </div>
      <span
        *ngIf="activeScreen === 'card'"
        class="text-xs m-auto mb-2 text-gray-600">
        {{ env.staticTextContents.loginModal.redirectionText.title }}
        <div>
          {{ env.staticTextContents.loginModal.redirectionText.subtitle }}
        </div>
      </span>
      <button
        [name]="submitBtnName"
        *ngIf="submitBtnTitle"
        class="btn bg-primary w-100 cursor-pointer text-white"
        [disabled]="submitBtnDisable"
        (click)="handleSubmit()">
        {{ submitBtnTitle }}
      </button>
      <button
        *ngIf="
          activeScreen === 'landing' || (activeScreen === 'mobile' && isSignUp)
        "
        class="btn bg-white text-primary w-100 font-semibold cursor-pointer"
        [ngClass]="submitBtnTitle ? 'mar-top-16' : ''"
        name="3ds-login-button"
        (click)="login(true)">
        <span class="gray-muted font-semibold">
          {{ env.staticTextContents.loginModal.returningUserLabel }}
        </span>
        {{ env.staticTextContents.commonTexts.loginButtonLabel }}
      </button>
      <button
        *ngIf="activeScreen === 'mobile' && !isSignUp"
        class="btn bg-white text-primary w-100 font-semibold cursor-pointer"
        [ngClass]="submitBtnTitle ? 'mar-top-16' : ''"
        name="3ds-signup-button"
        (click)="signup(true)">
        {{ env.staticTextContents.commonTexts.getStarted }}
      </button>
    </div>
  </ng-template>
</pv-drawer>
